import React, {Fragment} from 'react';
import dateformat from 'dateformat';
import ViewForm, {ViewFormField} from './ViewForm';
import {GridColumn} from '@atlaskit/page';
import {TextField, DatePickerField} from '../../../components/FormFields';
import Button, {ButtonGroup} from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import {EditViewContext} from './EditViewContext';
import i18n from 'i18next';
import {Trans} from 'react-i18next';

export const ClientPassportFields = ({
  passport,
  livingAddress,
  onChange,
  fetching,
}) => (
  <Fragment>
    <GridColumn medium={4}>
      <TextField
        name='passport.series'
        label={i18n.t('clients:Series')}
        placeholder={i18n.t('clients:Enter series')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={passport.series}
      />
    </GridColumn>
    <GridColumn medium={4}>
      <TextField
        name='passport.number'
        label={i18n.t('clients:No')}
        placeholder={i18n.t('clients:Enter passport number')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={passport.number}
      />
    </GridColumn>
    <GridColumn medium={4}>
      <DatePickerField
        name='passport.issuedAt'
        label={i18n.t('clients:Date of issue')}
        placeholder={i18n.t('ddmmyyyy')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={passport.issuedAt}
      />
    </GridColumn>
    <GridColumn medium={8}>
      <TextField
        name='passport.issuedBy'
        label={i18n.t('clients:Issued by')}
        placeholder={i18n.t('clients:Enter place of issue')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={passport.issuedBy}
      />
    </GridColumn>
    <GridColumn medium={4}>
      <TextField
        name='passport.authority'
        label={i18n.t('clients:Department code')}
        placeholder={i18n.t('clients:Enter department code')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={passport.authority}
      />
    </GridColumn>
    <GridColumn medium={12}>
      <TextField
        name='passport.regAddress'
        label={i18n.t('clients:Registration address')}
        placeholder={i18n.t('clients:Enter registration address')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={passport.regAddress}
      />
    </GridColumn>
    <GridColumn medium={12}>
      <TextField
        name='livingAddress'
        label={i18n.t('clients:Living address')}
        placeholder={i18n.t('clients:Enter living address')}
        required={true}
        onChange={onChange}
        isDisabled={fetching}
        value={livingAddress}
      />
    </GridColumn>
  </Fragment>
)

const ClientPassportEditFrom = ({
  passport,
  livingAddress,
  onChange,
  fetching,
  onCancel,
}) => (
  <Fragment>
      <ClientPassportFields
        passport={passport}
        livingAddress={livingAddress}
        onChange={onChange}
        fetching={fetching}
      />
      <GridColumn medium={12}>
        <FormFooter>
          <ButtonGroup>
            <Button appearance='subtle' isDisabled={fetching} onClick={onCancel}>
              <Trans>
                Cancel
              </Trans>
            </Button>
            <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='danger'>
              <Trans>
                Save
              </Trans>
            </Button>
          </ButtonGroup>
        </FormFooter>
      </GridColumn>
  </Fragment>
)

const ClientPassportViewFrom = ({passport, regAddress, livingAddress}) => (
  <Fragment>
    <ViewFormField label={i18n.t('clients:Series and No')} value={`${passport.series} ${passport.number}`} gridColumn={3} />
    <ViewFormField label={i18n.t('clients:Date of issue')} value={dateformat(passport.issuedAt, 'dd.mm.yyyy')} gridColumn={3} />
    <ViewFormField label={`${i18n.t('clients:Issued by')} | ${i18n.t('clients:Department code')}`} value={`${passport.issuedBy} | ${passport.authority ? passport.authority : 'н/д'}`} gridColumn={6} />
    <ViewFormField label={i18n.t('clients:Registration address')} value={passport.regAddress} gridColumn={12} />
    <ViewFormField label={i18n.t('clients:Living address')} value={livingAddress} gridColumn={12} />
  </Fragment>
)

export default props => {
  const formName = 'passport';
  return (
    <EditViewContext.Consumer>
      {({edit, permissions, onChangeEditMode, onChange}) => permissions.passport && (
        <ViewForm
          formName={formName}
          title={i18n.t('clients:Passport details')}
          actionName={permissions.passport.edit && i18n.t('Edit')}
          action={onChangeEditMode(formName)}
          editMode={edit === formName}
        >
          {edit === formName 
            ? <ClientPassportEditFrom {...props} onChange={onChange} /> 
            : <ClientPassportViewFrom {...props} />
          }
        </ViewForm>
      )}
    </EditViewContext.Consumer>
  );
}